import React from 'react';
import { BannerConfig } from '../../custom-types/banner';
import NewsTickerBanner from './NewsTickerBanner';
import useScreenSize from '../../hooks/useScreenSize';
import { useNavigate } from 'react-router-dom';

interface DynamicBannerProps {
  communityId: string;
  banner: BannerConfig;
  onClose: () => void;
}

const DynamicBanner: React.FC<DynamicBannerProps> = ({
  communityId,
  banner,
  onClose,
}) => {
  const screenSize = useScreenSize();
  const navigate = useNavigate();
  const isMobileScreen = ['mobile', 'tablet'].includes(screenSize);

  const handleClick = () => {
    if (banner.link) {
      if (banner.isInternalLink) {
        const internalLink = banner.link.replace(':communityId', communityId);
        navigate(internalLink);
      } else {
        window.open(banner.trackingLink, '_blank');
      }
    }
  };

  const renderContent = () => {
    if (banner.type === 'ad') {
      return (
        <div
          onClick={handleClick}
          style={{
            cursor: banner.link ? 'pointer' : 'default',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            color: banner.textColor || '#1A1A40',
            gap: banner.customStyles?.gap || 10,
            fontWeight: banner.customStyles?.fontWeight || 800,
            padding: banner.customStyles?.padding || 4,
          }}
        >
          {banner.imageUrl && (
            <img
              style={{
                width: `${banner.customStyles?.iconSize ?? 24}px`,
                height: `${banner.customStyles?.iconSize ?? 24}px`,
              }}
              src={banner.imageUrl}
              alt={banner.title}
            />
          )}
          {isMobileScreen ? (
            <span>{banner.message}</span>
          ) : (
            <>
              <span>{banner.message}</span>
              {banner.linkText && banner.link && (
                <span
                  style={{
                    fontWeight: 'bold',
                    fontStyle: 'italic',
                  }}
                >
                  {banner.linkText}
                </span>
              )}
            </>
          )}
        </div>
      );
    }
    return (
      <p
        style={{
          cursor: 'default',
          display: 'flex',
          alignItems: 'center',
          color: banner.textColor || 'white',
        }}
      >
        {banner.imageUrl && (
          <img
            src={banner.imageUrl}
            alt={banner.title}
            style={{ width: `${banner.customStyles?.iconSize ?? 24}px`, height: `${banner.customStyles?.iconSize ?? 24}px`, marginRight: '10px' }}
          />
        )}
        <span
          onClick={handleClick}
          style={{ cursor: banner.link ? 'pointer' : 'default' }}
        >
          {banner.message}
          {banner.linkText && banner.link && (
            <a
              onClick={(e) => {
                e.stopPropagation();
                handleClick();
              }}
              style={{
                textDecoration: 'underline',
                color: banner.textColor || '#1A1A40',
                marginLeft: '5px',
              }}
            >
              {banner.linkText}
            </a>
          )}
        </span>
      </p>
    );
  };

  return (
    <NewsTickerBanner
      bgColor={banner.bgColor || '#F5F1E6'}
      content={renderContent()}
      close={onClose}
    />
  );
};

export default DynamicBanner;
